import React from 'react';
import styled from 'styled-components';

const EndOfYear = () => (
  <NoticePositive>
    <HeaderPositive>
      <Icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
          />
        </svg>
      </Icon>
      Merry Christmas & Happy New Year!
    </HeaderPositive>
    <TextPositive>
      Searchlight Technology will be closed from <Bold>Monday 22 December</Bold> to{' '}
      <Bold>Monday 5 January</Bold>. If you need anything before we shut down, feel
      free to send it through early and we’ll make sure you’re looked after.
    </TextPositive>
  </NoticePositive>
);

const PriceChange = () => (
  <Notice>
    <Header>
      <Icon>
        <path
          fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </Icon>
      Strata & Community Fee Update
    </Header>
    <Text>
      New prescribed fees apply from 1 September 2026 under the <i style={{ fontWeight: 500 }}>Community Titles Regulations 2026 and Strata Titles (Miscellaneous) Amendment Regulations 2026.</i>
    </Text>
  </Notice>
);

export const Form1Notice = () => (
  <NoticePositive>
    <HeaderPositive>
      <Icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
          />
        </svg>
      </Icon>
      Simplify your Form 1 preparation with Searchlight.
    </HeaderPositive>
    <TextPositive>
      Fast, accurate pre-population that keeps you in full control through to final
      approval. Easy ordering. Secure payment. Real-time updates. Form 1 preparation,
      made easy.
    </TextPositive>
  </NoticePositive>
);

const UpdateRequest = () => (
  <NoticePositive>
    <HeaderPositive>
      <Icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
          />
        </svg>
      </Icon>
      July Rate Updates
    </HeaderPositive>
    <TextPositive>
      You can easily order your updated Section 187 through our portal. To do this,
      select the property with a completed search from your dashboard, click the
      "Request Update" button, and your request will be promptly processed. For more
      info, see our video guide{' '}
      <a
        href="https://youtu.be/emHyPlZYIFo?si=zqhQ0a7Ee8F7yBt4"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>
      .
    </TextPositive>
  </NoticePositive>
);

export const PostPaidNotice = () => {
  return (
    <NoticePositive>
      <HeaderPositive>
        <Icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
            />
          </svg>
        </Icon>
        Your Account - Monthly Billing
      </HeaderPositive>
      <TextPositive>
        Your account is currently set to monthly billing. For any enquiries, please
        contact us on <Bold>08 7082 4270</Bold> or email{' '}
        <Bold>info@searchlighttechnology.com.au</Bold>.
      </TextPositive>
    </NoticePositive>
  );
};

const Notice = styled.div`
  background-color: #fffbeb;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-left-width: 2px;
  border-left-style: solid;
  margin-left: auto;
  margin-right: auto;
  border-left-color: #fbbf24;
`;

const NoticePositive = styled.div`
  background-color: #eff6ff;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-left-width: 2px;
  border-left-style: solid;
  margin-left: auto;
  margin-right: auto;
  border-left-color: #3b82f6;
`;

const Header = styled.h1`
  color: #92400e;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  margin: 0rem;
  display: flex;
  margin-bottom: 0.5rem;
  align-items: center;
`;

const HeaderPositive = styled.h1`
  color: #1d4ed8;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  margin: 0rem;
  display: flex;
  margin-bottom: 0.5rem;
  align-items: center;
`;

const Text = styled.p`
  margin: 0rem;
  color: #b45309;
  font-size: 0.875rem;
  line-height: 1.5;
`;

const TextPositive = styled.p`
  margin: 0rem;
  color: #2d4453;
  font-size: 0.875rem;
  line-height: 1.5;
`;

const Bold = styled.span`
  font-weight: 500;
`;

const Icon = styled.svg`
  width: 1.25rem;
  height: 1.25rem;
  color: #fbbf24;
  margin-right: 0.5rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
`;

Icon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 20 20',
  fill: 'currentColor',
  ariaHidden: 'true',
};

export { EndOfYear, PriceChange, UpdateRequest };
